import Cookies from 'js-cookie'
import { Outlet } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import { SearchProvider } from '@/context/search-context'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar'
import SkipToMain from '@/components/skip-to-main'
import { UploadModal } from '@/components/upload/uploadmodal';
import { useEffect, useState } from 'react'

interface Props {
  children?: React.ReactNode
}

export function AuthenticatedLayout({ children }: Props) {
  const defaultOpen = Cookies.get('sidebar_state') !== 'false'
  const [isUploadOpen, setIsUploadOpen] = useState(false)

  useEffect(() => {
    const handleOpenUploadModal = () => setIsUploadOpen(true)

    window.addEventListener('open-upload-modal', handleOpenUploadModal)
    return () => window.removeEventListener('open-upload-modal', handleOpenUploadModal)
  }, [])

  return (
    <SearchProvider>
      <SidebarProvider defaultOpen={defaultOpen}>
        <div className="flex min-h-screen w-full mx-4 my-1">  
          <AppSidebar 
            className="peer" 
            onScheduleClick={() => setIsUploadOpen(true)}
          />
          <div
            id='content'
            className={cn(
              'ml-auto w-full max-w-full',
              'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
              'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
              'sm:transition-[width] sm:duration-200 sm:ease-linear',
              'flex flex-col',
              'group-data-[scroll-locked=1]/body:h-full',
              'has-[main.fixed-main]:group-data-[scroll-locked=1]/body:h-svh'
            )}
          >
            {children ? children : <Outlet />}
          </div>
        </div>
        <SkipToMain />
        
        {/* Upload Modal accessible from anywhere in the app */}
        <UploadModal
          open={isUploadOpen}
          onOpenChange={setIsUploadOpen}
          onDraftSaved={() => {
            // Trigger a refresh event that your dashboard can listen to
            window.dispatchEvent(new Event('refresh-uploads'))
          }}
        />
      </SidebarProvider>
    </SearchProvider>
  )
}